// core components
import SelectDealerGrouped from "../components/SelectDealerGrouped/SelectDealerGrouped";
import GridContainer from "../components/Grid/GridContainer.js";
import GridItem from "../components/Grid/GridItem.js";
import Card from "../components/Card/Card.js";
import CardHeader from "../components/Card/CardHeader.js";
import CardIcon from "../components/Card/CardIcon.js";
import CardBody from "../components/Card/CardBody.js";

// @material-ui/icons
import { Assignment } from "components/MaterialSymbol/MaterialIcons";

export default function PageLayout({
    children,
    showSelectDealer = true,
    showAllDealers = false,
    customComponent,
    className = "",
    ...otherProps
}) {
    return (
        <GridContainer
            {...otherProps}
            className={`shadcn-page-layout ${
                showSelectDealer
                    ? "shadcn-page-layout-with-dealer"
                    : "shadcn-page-layout-without-dealer"
            } ${className}`.trim()}
        >
            {showSelectDealer && (
                <GridItem xs={12} className="shadcn-select-dealer-row">
                    <SelectDealerGrouped showAllDealers={showAllDealers} />
                </GridItem>
            )}
            <GridItem xs={12}>
                <Card>
                    <CardHeader icon color="primary">
                        <CardIcon color="primary" className="custom-card-icon">
                            <Assignment />
                        </CardIcon>
                        {customComponent}
                    </CardHeader>
                    <CardBody>{children}</CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    );
}
